import React from 'react';

export default function SocialWidget() {
  return (
    <div className="cs_developed_by">
      Developed by{' '}
      <a
        href="https://jskwwc.com/digital-agency/"
        target="_blank"
        rel="noopener noreferrer"
      >
        JSKWWC
      </a>
    </div>
  );
}
